import { render } from "./InvoiceRegistrationEdit.vue?vue&type=template&id=1ddaca81"
import script from "./InvoiceRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceRegistrationEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__